// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"888":"7e42aecb","1836":"ce1a019c"}[chunkId] || chunkId) + "." + {"888":"52768f8d5a7d16aa","1836":"bb5aa238fc1da0d5","9307":"c5810afc446debd2"}[chunkId] + ".js";
};